import StatusErrorPage from '@components/Error/StatusErrorPage';

const Error500 = () => <StatusErrorPage title="Server Error" code={500} />;

export default Error500;
